export const useQuery = queryParam => {
  const search = new URLSearchParams(window.location.search);
  return search.get(queryParam);
};

export default {
  useQuery,
}
